import React from 'react'
import './CookiePolicy.css'

const CookiePolicy = () => {
    return (
        <div className='cookiep'>
            <div className='container spaceing-box'>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='term-headings'>
                            <h2>Cookie Policy</h2>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='conditions-per'>
                            <p>If your website tracks personal information through the use of cookies or similar technologies, for example, you must make this clear to your site visitors. Be clear about what tracking tools (e.g. cookies, flash cookies, web beacons, etc.,) your website employs, what personal information they gather and why they are being used.
                            </p>
                            <p>It's important to note that third-party services, such as Google Analytics or other applications offered through Wix, placing cookies or utilizing other tracking technologies through Wix´s services, may have their own policies regarding how they collect and store information. As these are external services, such practices are not covered by the Wix Privacy Policy.</p>
                            <p>You can check out this <a href='#'>support article</a> to receive more information about cookies and your Wix site.</p>
                        </div>
                    </div>
                </div>
            </div>
            <hr class="hori-line" />
            <div className='container spaceing-box'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='text-bottom2'>
                            <p>
                                The explanations and information provided herein are only general explanations, information and samples. You should not rely on this article as legal advice or as recommendations regarding what you should actually do. We recommend that you seek legal advice to help you understand and to assist you in the creation of your privacy policy.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default CookiePolicy;



